import { FunctionalComponent, h } from 'preact';
import './move-hide.scss';
import { GearIcon } from '@uw/icons';
import { useRef, useState } from 'preact/hooks';
import { HideWidget } from './hide-widget';
import { useTranslation } from '../../services/use-translation';
import { usePosition } from './use-position';
import { ExpandPanel } from '../expand-panel/expand-panel';

// values according to the old data-grid positioning
enum Position {
  Left = 7,
  Center = 5,
  Right = 1,
}

export const MoveHide: FunctionalComponent = () => {
  const { translate } = useTranslation();
  const [hide, setHide] = useState(false);
  const { currentPosition, savePosition } = usePosition(() => setHide(false));
  const container = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={container}
      className="uwaw-move-hide-component"
      data-uw-reader-content={translate('widget.menu.moveHide.aria')}
    >
      <ExpandPanel
        title={translate('widget.manageHideMove.title')}
        icon={<GearIcon width={12} height={12} />}
        scrollDown={true}
        readerText={translate('widget.menu.moveHide.aria')}
      >
        <div className="uwaw-move-hide">
          <div className="uwaw-move-hide__list">
            <div className="uwaw-move-hide__item">
              <label htmlFor="uwaw-move-l" className="uwaw-custom-radio">
                <input
                  className="uwaw-custom-radio__inp"
                  type="radio"
                  name="moveHide"
                  id="uwaw-move-l"
                  data-uw-reader-content={translate('widget.manageHideMove.radio_icons.icons_aria_labels.left')}
                  checked={currentPosition === Position.Left}
                  onInput={() => savePosition(Position.Left)}
                />
                <span className="uwaw-custom-radio__icon" />
                <span className="uwaw-custom-radio__label">
                  {translate('widget.manageHideMove.radio_icons.left')}
                </span>
              </label>
            </div>

            <div className="uwaw-move-hide__item">
              <label htmlFor="uwaw-move-r" className="uwaw-custom-radio">
                <input
                  className="uwaw-custom-radio__inp"
                  type="radio"
                  name="moveHide"
                  id="uwaw-move-r"
                  data-uw-reader-content={translate('widget.manageHideMove.radio_icons.icons_aria_labels.right')}
                  checked={currentPosition === Position.Right}
                  onInput={() => savePosition(Position.Right)}
                />
                <span className="uwaw-custom-radio__icon" />
                <span className="uwaw-custom-radio__label">
                  {translate('widget.manageHideMove.radio_icons.right')}
                </span>
              </label>
            </div>

            <div className="uwaw-move-hide__item">
              <label htmlFor="uwaw-move-h" className="uwaw-custom-radio">
                <input
                  className="uwaw-custom-radio__inp"
                  type="radio"
                  name="moveHide"
                  id="uwaw-move-h"
                  data-uw-reader-content={translate('widget.manageHideMove.radio_icons.icons_aria_labels.hide')}
                  checked={hide}
                  onInput={(e) => setHide(true)}
                />
                <span className="uwaw-custom-radio__icon" />
                <span className="uwaw-custom-radio__label">
                  {translate('widget.manageHideMove.radio_icons.hide')}
                </span>
              </label>
            </div>
          </div>

          {hide && (
            <HideWidget
              onCancel={() => {
                setHide(false);
              }}
            />
          )}
        </div>
      </ExpandPanel>
    </div>
  );
};
